wbApp.directive('wbOnlyOneValueSetValidator', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            wbOnlyOneValueSetValidator: '='
        },
        link: function (scope, elem, attr, ctrl) {

            function validate(value1, value2) {
                var val1Def = (!isNaN(value1) && value1 !== null && value1 !== '') || !String.prototype.isNullOrWhitespace(value1);
                var val2Def = (!isNaN(value2) && value2 !== null && value2 !== '') || !String.prototype.isNullOrWhitespace(value2);

                ctrl.$setValidity('onlyOneValueSet', (val1Def && !val2Def) || (!val1Def && val2Def));
            }

            scope.$watch('wbOnlyOneValueSetValidator', function (model) {
                validate(model, ctrl.$viewValue);
            });

            ctrl.$parsers.unshift(function (model) {
                validate(model, scope.wbOnlyOneValueSetValidator);

                return model;
            });
        }
    };
}]);